'use strict';

angular.module('licensure.services')
    .factory('LicenseCategoryCertificationFields', ['$http', '$q', function ($http, $q) {
        return {
            get: function (license_category_id) {
                var d = $q.defer();

                $http
                    .get(apiLocation + '/api/licensecategorycertificationfields', {
                        params: {
                            license_category_id: license_category_id
                        }
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            },

            save: function (license_category_certification_field) {
                var d = $q.defer();

                var method = 'POST';
                var url = apiLocation + '/api/licensecategorycertificationfields/';
                if (!isUndefined(license_category_certification_field.id)) {
                    method = 'PUT'
                    url += license_category_certification_field.id
                }

                $http({
                    method: method,
                    url: url,
                    data: {
                        license_category_certification_field: license_category_certification_field
                    }
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            }
        }
    }])
;